import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vShow as _vShow, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "area_body" }
const _hoisted_3 = { class: "area_section" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "area_section" }
const _hoisted_6 = { class: "area_form" }
const _hoisted_7 = { class: "area_form_body" }
const _hoisted_8 = { class: "area_row" }
const _hoisted_9 = { class: "area_col_body" }
const _hoisted_10 = { class: "area_row" }
const _hoisted_11 = { class: "area_col_body" }
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "area_row" }
const _hoisted_14 = {
  class: "area_col_body",
  style: {"position":"relative"}
}
const _hoisted_15 = { class: "flex ac" }
const _hoisted_16 = { class: "area_button" }
const _hoisted_17 = {
  class: "select-wrap",
  style: {"position":"absolute","top":"40px"}
}
const _hoisted_18 = ["value", "textContent"]
const _hoisted_19 = { class: "area_row" }
const _hoisted_20 = { class: "area_col_row" }
const _hoisted_21 = { class: "flex ac" }
const _hoisted_22 = ["textContent"]
const _hoisted_23 = { class: "area_button" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "area_row" }
const _hoisted_27 = { class: "area_col_body" }
const _hoisted_28 = ["textContent"]
const _hoisted_29 = { class: "area_button area_form_btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "area_title" }, [
          _createElementVNode("p", null, "내담자 그룹관리")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: $setup.state.data.file,
              style: {"width":"300px","height":"auto"}
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "1. 그룹명")
                  ], -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.data.name) = $event))
                      }, null, 512), [
                        [_vModelText, $setup.state.data.name]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "2. 작성자")
                  ], -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        textContent: _toDisplayString($setup.state.data.adName)
                      }, null, 8, _hoisted_12)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "3. 내담자 검색")
                  ], -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.searchNumber) = $event)),
                          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => ($setup.findClient()), ["enter"])),
                          class: "w300"
                        }, null, 544), [
                          [_vModelText, $setup.state.searchNumber]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.findClient && $setup.findClient(...args))),
                          class: "type2"
                        }, _cache[11] || (_cache[11] = [
                          _createElementVNode("span", null, "검색", -1)
                        ]))
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.selectedItem) = $event)),
                        onChange: _cache[5] || (_cache[5] = ($event: any) => {
                                                $setup.state.data.client.push({
                                                    clIdx: $setup.state.selectedItem.idx,
                                                    vstNo: $setup.state.selectedItem.number,
                                                });

                                                $setup.state.isSearch = false;
                                                $setup.state.selectedItem = {};
                                                $setup.state.list = [];
                                            })
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.list, (item, key) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: { number: item.number, idx: item.idx },
                            textContent: _toDisplayString(item.number),
                            key: key
                          }, null, 8, _hoisted_18))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, $setup.state.selectedItem]
                      ])
                    ], 512), [
                      [_vShow, $setup.state.isSearch]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "3-1. 내담자")
                  ], -1)),
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.client, (item, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "area_col no-line-bottom",
                        key: key
                      }, [
                        _createElementVNode("div", _hoisted_21, [
                          _cache[13] || (_cache[13] = _createElementVNode("img", { src: "img/icon_client.png" }, null, -1)),
                          _createElementVNode("p", {
                            textContent: _toDisplayString(item.vstNo),
                            class: "vst_name"
                          }, null, 8, _hoisted_22),
                          _createElementVNode("div", _hoisted_23, [
                            (item.idx)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: ($event: any) => ($setup.confirmRemoveMember(item.idx)),
                                  class: "type3"
                                }, "삭제", 8, _hoisted_24))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: ($event: any) => ($setup.state.data.client.splice(key, 1)),
                                  class: "type3"
                                }, "삭제", 8, _hoisted_25))
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "4. 등록일자")
                  ], -1)),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        textContent: _toDisplayString($setup.CommonUtils.dateFormat($setup.state.data.createDate, '.', true))
                      }, null, 8, _hoisted_28)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              ($setup.state.mode)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.confirmAdd && $setup.confirmAdd(...args))),
                    class: "active"
                  }, _cache[16] || (_cache[16] = [
                    _createElementVNode("span", null, "등록", -1)
                  ])))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.confirmModify && $setup.confirmModify(...args))),
                      class: "active"
                    }, _cache[17] || (_cache[17] = [
                      _createElementVNode("span", null, "수정", -1)
                    ])),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.confirmRemove && $setup.confirmRemove(...args))),
                      class: "delete"
                    }, _cache[18] || (_cache[18] = [
                      _createElementVNode("span", null, "삭제", -1)
                    ]))
                  ], 64))
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          gubun: $setup.state.gubun,
          idx: $setup.state.removeIdx,
          onClose: $setup.closeModal,
          onCallback: $setup.callbackModal
        }, null, 8, ["type", "title", "content", "gubun", "idx", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}